import { render, staticRenderFns } from "./PdaDesktopCategories.vue?vue&type=template&id=502cc86d&scoped=true&"
import script from "./PdaDesktopCategories.vue?vue&type=script&lang=js&"
export * from "./PdaDesktopCategories.vue?vue&type=script&lang=js&"
import style0 from "./PdaDesktopCategories.vue?vue&type=style&index=0&id=502cc86d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502cc86d",
  null
  
)

export default component.exports